module.exports = __webpack_public_path__ + "img/aaa.ec60c98b.png";